import { Link } from '@@/Link';

import { helper } from './helper';

export const inheritedName = helper.accessor('Name', {
  cell({ row: { original: item }, getValue }) {
    const name = getValue();

    return (
      <>
        {name}
        {item.Inherited && item.PolicyID && (
          <span className="text-muted small">
            <code className="text-sm">
              <Link
                data-cy="inherited-policy-link"
                to="portainer.policy"
                params={{ id: item.PolicyID }}
              >
                inherited
              </Link>
            </code>
          </span>
        )}
        {item.Inherited && !item.PolicyID && (
          <span className="text-muted small">
            <code className="text-sm">inherited</code>
          </span>
        )}
        {item.Override && (
          <span className="text-muted small">
            <code className="text-sm">override</code>
          </span>
        )}
      </>
    );
  },
});
